import { render, staticRenderFns } from "./CampaignStatistics.vue?vue&type=template&id=4cd1ba81"
import script from "./CampaignStatistics.vue?vue&type=script&lang=js"
export * from "./CampaignStatistics.vue?vue&type=script&lang=js"
import style0 from "./CampaignStatistics.vue?vue&type=style&index=0&id=4cd1ba81&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports